export default __webpack_public_path__ + "static/media/computerGuy.b1d27531.svg";